import React from 'react';
import Filter from '../components/Filter';
import ProductsGrid from '../components/ProductsGrid';
import products from '../css/products.module.css';
import SortButton from '../components/SortButton';

const Products = (props) => {
    return (
        <div className={products.bg}>
            <Filter />
            <div>
                <SortButton />
                <ProductsGrid />
            </div>
        </div>
    );
};

export default Products;
